<template>
  <div>
    <el-dialog width="45%" @close="close" :visible.sync="dialogFormVisible">
      <div class="title">淮河能源控股集团员工保障信息服务平台</div>
      <div class="form">
        <el-form
          :rules="rules"
          ref="form"
          label-position="left"
          :model="form"
          class="form-content"
        >
          <el-form-item
            label="身份证号码"
            prop="card"
            :label-width="formLabelWidth"
          >
            <el-input v-model="form.card"></el-input>
          </el-form-item>
          <el-form-item
            label="登录密码"
            prop="password"
            :label-width="formLabelWidth"
          >
            <el-input type="password" v-model="form.password"></el-input>
          </el-form-item>
          <el-form-item
            label="确认密码"
            prop="confirmPassword"
            :label-width="formLabelWidth"
          >
            <el-input type="password" v-model="form.confirmPassword"></el-input>
          </el-form-item>
          <el-form-item label="姓名" prop="name" :label-width="formLabelWidth">
            <el-input v-model="form.name"></el-input>
          </el-form-item>
          <el-form-item
            label="手机号码"
            prop="phone"
            :label-width="formLabelWidth"
          >
            <el-input v-model="form.phone"></el-input>
          </el-form-item>
          <el-form-item
            label="验证码"
            prop="code"
            :label-width="formLabelWidth"
          >
            <el-input v-model="form.code">
              <el-button
                slot="append"
                class="getCode"
                @click="throttle(getCode)"
                v-show="show"
                >获取验证码</el-button
              >
              <!-- <el-button slot="append" v-show="!show" class="getCode"
                >重新发送（{{ count }}s）</el-button
              > -->
              <template slot="append" v-if="!show">{{ count }}s</template>
            </el-input>
          </el-form-item>
        </el-form>
      </div>
      <div class="btn">
        <el-button @click="register" type="primary">注册</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import request from "@/api/loginAndRegister";
import md5 from "js-md5";
export default {
  data() {
    var validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else if (value !== this.form.password) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };
    var isCardId = (rule, value, callback) => {
      if (!value) {
        callback(new Error("请输入身份证号码"))
      } else {
        const reg = /^(^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$)|(^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])((\d{4})|\d{3}[X])$)$/;
        const card = reg.test(value);
        if (!card) {
          callback(new Error("身份证号码格式有误！"))
        } else{
          callback();
        } 
      }
    };
    return {
      dialogFormVisible: false,
      form: {
        name: "",
        password: "",
        confirmPassword: "",
        card: "",
        phone: ""
      },
      formLabelWidth: "120px",
      show: true, // 初始启用按钮
      count: 60, // 初始化次数
      timer: null,
      onoff: true,
      rules: {
        card: [
          { required: true, validator: isCardId, trigger: "blur" }
        ],
        password: [
          { required: true, message: "请输入密码", trigger: "blur" },
          {
            pattern: /^(?=.*\d)(?=.*[a-zA-Z])(?=.*[`~!@#$%^&*()\-_+=,./<>?])[\da-zA-Z`~!@#$%^&*()\-_+=,./<>?]{10,18}$/,
            message: "密码必须包含数字、字母和特殊字符并且长度10-18位"
          }
        ],
        confirmPassword: [
          { required: true, validator: validatePass, trigger: "blur" }
        ],
        phone: [
          {
            required: true,
            message: "请输入手机号",
            trigger: "blur"
          },
          {
            type: "string",
            pattern: /^1(3|4|5|6|7|8|9)\d{9}$/,
            message: "请输入有效的手机号码",
            trigger: "blur"
          }
        ],
        name: [{ required: true, message: "请输入姓名", trigger: "blur" }],
        code: [{ required: true, message: "请输入验证码", trigger: "blur" }]
      }
    };
  },
  watch: {
    registerVisible() {
      this.dialogFormVisible = this.registerVisible;
    }
  },
  computed: {
    registerVisible() {
      return this.$store.getters.registerDialog;
    }
  },
  mounted() {
    this.onoff = true;
    this.$store.commit("closeRegister");
  },
  methods: {
    close() {
      this.$store.commit("closeRegister");
      this.$refs.form.resetFields();
    },
    // 处理多次点击
    throttle(fn, params) {
      let that = this;
      if (that.onoff && fn) {
        that.onoff = false;
        if (params) {
          fn(params);
        } else {
          fn();
        }
        setTimeout(function() {
          that.onoff = true;
        }, 1500);
      } else {
        console.log("请稍后点击");
      }
    },
    getCode() {
      if (!this.form.phone) {
        this.$message({
          type: "error",
          message: "手机号不能为空"
        });
        return;
      }
      const para = {
        phone: this.form.phone
      };
      request
        .sendCode(para)
        .then(res => {
          console.log(res); //倒计时
          this.timer = setInterval(() => {
            if (this.count > 0) {
              this.show = false;
              this.count--;
              console.log(this.count);
            } else {
              this.show = true;
              clearInterval(this.timer); // 清除定时器
              this.timer = null;
              this.count = 60;
            }
          }, 1000);
        })
        .catch(err => {
          console.log(err);
        });
    },
    /* 注册 */
    register() {
      this.$refs.form.validate(async valid => {
        if (valid) {
          const para = {
            password: md5(md5(this.form.password)),
            xm: this.form.name,
            yxzjhm: this.form.card,
            sjhm: this.form.phone,
            sjyzm: this.form.code,
            loginname: ""
          };
          await request.register(para);
          this.$message({
            type: "success",
            message: "注册成功"
          });
          this.$store.commit("closeRegister");
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header {
  padding: 0px 20px 0px;
}
.title {
  font-size: 24px;
  text-align: center;
  font-weight: 700;
  margin-bottom: 20px;
}
.btn {
  display: flex;
  justify-content: center;
}
.form {
  display: flex;
  justify-content: center;
  .form-content {
    width: 65%;
  }
}
</style>
